import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AssetsState = {
  loading: boolean;
  assetsCounts: number;
};

const initialState: AssetsState = {
  loading: false,
  assetsCounts: 0,
};

const assets = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    setLoading(state, { payload }: PayloadAction<boolean>) {
      state.loading = payload;
    },
    setAssetsCounts(state, { payload }: PayloadAction<number>) {
      state.assetsCounts = payload;
    },
  },
});

export const { setLoading, setAssetsCounts } = assets.actions;
export const selectAssetsCount = (state: { assets: AssetsState }) => state.assets.assetsCounts;
export const selectAssetLoading = (state: { assets: AssetsState }) => state.assets.loading;

export default assets.reducer;
